<template>
  <section class="vz-page vz-page-notfound">
    <h1 class="vz-title">Não encontrado</h1>
    <p class="vz-p">O endereço que você tentou acessar não é válido.</p>
    <p class="vz-bts">
      <nuxt-link class="vz-link-primary" to="/"
        >Vá para a página inicial
      </nuxt-link>
    </p>
  </section>
</template>

<script>
export default {
  name: 'NotFound'
};
</script>





















<style theme="light-theater" scoped>
.vz-page-notfound {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  min-height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-repeat: no-repeat;
  background-position: center top;
  background-size: cover;
  background-image: url(~client/img/bg-movies-blur.jpg);
  text-align: center;
  padding: 32px;
}
</style>
